import { Navigate, Outlet } from "react-router-dom";
import { AuthLoadingScreen } from "../components/auth/AuthLoadingScreen";
import { useResilientSession } from "../hooks/useResilientSession";

/**
 * GuestOnlyRoute - Redirects authenticated users to the dashboard
 * Used for pages like /sign-in and /sign-up where logged-in users shouldn't be
 */
export const GuestOnlyRoute = () => {
  const { data: session, isPending } = useResilientSession();

  // Show loading while checking session
  if (isPending) {
    return <AuthLoadingScreen />;
  }

  // If user is logged in, redirect to dashboard
  if (session?.user) {
    return <Navigate to="/dashboard" replace />;
  }

  // User is not logged in, show the guest page (sign-in/sign-up)
  return <Outlet />;
};
